var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(['asia_uat', 'asia'].includes(_vm.$store.state.tenantId))?_c('asia-reports-home'):_c('default-reports-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }